<div class="flex flex-col w-full h-full overflow-hidden">
  @if (isLoading | async) {
    @if (!doNotShowLoadingSpinner()) {
      <div class="flex flex-row space-x-2">
        <app-loading [classes]="['h-6', 'w-6']" [noWhitespace]="true" [hideText]="true"></app-loading>
      </div>
    }
  } @else {
    <app-image-slider
      class="flex flex-col w-full h-full"
      [items]="(items | async) || []"
      [enableOverlay]="true"
      [fullScreen]="true"
      [hideOriginalImage]="true"
    ></app-image-slider>
  }
</div>
